import { renderInDocument } from '@spotahome/soyuz/client';

import SeoPage from './SeoPage';

renderInDocument(SeoPage);
